import React from 'react';
import PropTypes from 'prop-types';
import SaveButton from './SaveButton';
import AddToPlaylistButton from './AddToPlaylistButton';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const VideoActions = ({ video, isPromo = false, onUnlockFullLibrary }) => {
	if (isPromo) {
		return (
			<div className="c-mobile_vide-icon">
				<button type="button" className="sign-up-btn promo-unlock-library-btn" onClick={onUnlockFullLibrary}>
					Unlock Full Library <ArrowForwardIcon fontSize="small" />
				</button>
			</div>
		);
	}

	return (
		<div className="c-mobile_vide-icon">
			<ul>
				<SaveButton videoId={video?._id} isSaved={video?.savedvideo} />
				<AddToPlaylistButton selectedVideo={video} />
			</ul>
		</div>
	);
};

VideoActions.propTypes = {
	video: PropTypes.shape({
		_id: PropTypes.string,
		savedvideo: PropTypes.bool
	}),
	isPromo: PropTypes.bool,
	onUnlockFullLibrary: PropTypes.func
};

export default VideoActions;
